module.exports = __webpack_public_path__ + "static/img/newbg.2aa8189.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplyFinance/newbg.png
// module id = yoTC
// module chunks = 44